import {
    forwardRef,
    useImperativeHandle,
} from 'react'

// Employment location is fixed to the United States — no other country is
// currently selectable. The ref still exposes validateAndGetData() so the
// create form keeps working unchanged.
const FIXED_COUNTRY = "United States"

const CountryInput = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => ({
            isValid: true,
            value: {
                country: FIXED_COUNTRY,
            },
        }),
    }))

    return (
        <div className="text-left">
            <label
                className="block text-sm text-gray-800 mb-2"
                htmlFor="country"
            >
                Country
            </label>
            <input
                id="country"
                name="country"
                type="text"
                value={FIXED_COUNTRY}
                disabled
                readOnly
                aria-readonly="true"
                className="border border-gray-300 rounded-md p-2 bg-gray-100 text-gray-600 w-full cursor-not-allowed"
            />
            <p className="text-xs text-gray-400 mt-1">
                Employment location is currently available for the United States only.
            </p>
        </div>
    )
})

export default CountryInput
